import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as moment from "moment";
import { of } from "rxjs";
import { catchError, exhaustMap, map, mergeMap, take, takeLast, tap } from "rxjs/operators";
import { AppState } from "src/app/core/models/app-state.models";
import { EndpointName } from "src/app/core/models/endpoints.models";
import { APIService } from "src/app/core/services/api.service";
import { SessionService } from "src/app/core/services/session.service";

import { sessionActions, authActions} from "../actions";



@Injectable()
export class AuthEffects {

    private loginRequest$ = createEffect(
        () => this.actions$.pipe(
            ofType(authActions.loginRequest),
            exhaustMap(action => {
                this.store.dispatch(sessionActions.showAppLoader());
                return this.apiService.post(EndpointName.login, action.login)
                    .pipe(
                        mergeMap(response => {
                            return [
                                sessionActions.hideAppLoader(),
                                authActions.loginSuccess({ data: response.data })];
                        }),
                        catchError(error => of(
                            authActions.loginFailed(),
                            sessionActions.hideAppLoader()
                        ))
                    )
            })
        )
    );

    private loginSuccess$ = createEffect(
        () => this.actions$.pipe(
            ofType(authActions.loginSuccess),
            tap(action => {
                if(localStorage.getItem('login_scope')) {
                    localStorage.removeItem('login_scope');
                    localStorage.removeItem('login_scope_t');
                    this.store.dispatch(sessionActions.unblockLogin());
                }
                

              
            }),
            mergeMap(data => [
                sessionActions.sessionLoggedIn(),
                sessionActions.updateAuthToken({ token: data.data.token }),
                
            ])
        )
    );

    private loginFailed$ = createEffect(
        () => this.actions$.pipe(
            ofType(authActions.loginFailed),
            map(action => {
                if(!localStorage.getItem('login_scope')) localStorage.setItem('login_scope', JSON.stringify(1));
                else {
                    // if(localStorage.getItem('login_scope_t')) {
                    //     const blockedTime = JSON.parse(localStorage.getItem('login_scope_t'))
                    //     const expireTime = moment(blockedTime).add(30, 'minutes').format();
                    //     const currentTime = moment().format();
                    //     if(moment(expireTime).isBefore(currentTime)){
                    //         // create function for the below code
                    //         localStorage.removeItem('login_scope');
                    //         localStorage.removeItem('login_scope_t');
                    //         this.store.dispatch(sessionActions.unblockLogin());
                    //     }else {
                    //         this.store.dispatch(sessionActions.blockLogin());
                    //     }
                    // }
                    this.SessionService.validateLoginBlock()
                    const currentCount = JSON.parse(localStorage.getItem('login_scope'));
                    localStorage.setItem('login_scope', JSON.stringify(currentCount + 1));
                    if((currentCount + 1) >= 5){
                         localStorage.setItem('login_scope_t', moment().format());
                         this.store.dispatch(sessionActions.blockLogin());
                         const unBlockTimer = setTimeout(() => {
                             localStorage.removeItem('login_scope');
                             localStorage.removeItem('login_scope_t');
                             this.store.dispatch(sessionActions.unblockLogin());
                         }, (30 * 60 * 1000));
                    }                     
                }
            }),
            mergeMap(data => [                
                sessionActions.sessionLoggedOut(),
                sessionActions.updateAuthToken({ token: null }),
               
            ])
        )
    );

    private logoutRequest$ = createEffect(
        () => this.actions$.pipe(
            ofType(authActions.logoutRequest),
            exhaustMap(action => {
                this.store.dispatch(sessionActions.showAppLoader());
                return this.apiService.post(EndpointName.logout, {})
                    .pipe(
                        mergeMap(response => {
                            return [
                                sessionActions.hideAppLoader(),
                                authActions.logoutSuccess()];
                        }),
                        catchError(error => of(
                            authActions.logoutFailed(),
                            sessionActions.hideAppLoader(),
                        ))
                    )
            })
        )
    )

    private logoutSuccess$ = createEffect(
        () => this.actions$.pipe(
            ofType(authActions.logoutSuccess),
            tap(action => {
                this.router.navigate(['/auth', 'login']);
                
            }),
            mergeMap(data => [])
        ),
        { dispatch: false }
    );

    private logoutFailed$ = createEffect(
        () => this.actions$.pipe(
            ofType(authActions.logoutFailed),
            map(action => {
                this.router.navigate(['/auth', 'login']);
                
            })
        ),
        { dispatch: false }
    );

    constructor(
        private actions$: Actions,
        private apiService: APIService,
        private router: Router,
        private store: Store<AppState>,
        
        private SessionService: SessionService,
        
    ) { }
}
